import { postMeetup as en_postMeetup } from "../en/post-meetup";

/** post-meetup — ES slice (31 keys). */
export const postMeetup: Record<keyof typeof en_postMeetup, string> = {
  post_meetup_prompt_title: "¿Qué tal tu encuentro con {name}?",
  post_meetup_prompt_subtitle:
    "¿Quieres intercambiar tus datos de contacto? Si ambos hacéis match, se compartirán vuestras tarjetas Linqx.",
  post_meetup_prompt_disclaimer:
    '"Ahora no" = rechazar. Tu elección es privada.',
  post_meetup_match_button: "Match",
  post_meetup_not_now_button: "Ahora no",
  post_meetup_waiting_title: "Esperando a que {name} responda...",
  post_meetup_waiting_subtitle: "Elegiste: Match",
  post_meetup_waiting_notify: "Te avisaremos cuando haya un resultado",
  post_meetup_withdraw_button: "Retirar",
  post_meetup_done_button: "Listo",
  post_meetup_connected_title: "¡Ya estáis conectados!",
  post_meetup_connected_subtitle:
    "Ahora puedes ver la tarjeta Linqx de {name}.",
  post_meetup_linqx_card_button: "Tarjeta Linqx",
  post_meetup_no_vibe_title: "No hubo feeling con {name}",
  post_meetup_no_vibe_subtitle: "¡Desliza para hacer match con otra persona!",
  post_meetup_explore_button: "Explorar",
  post_meetup_expired_title: "Tu match con {name} ha caducado",
  post_meetup_expired_subtitle:
    "Aún puedes volver a hacer match desde el chat.",
  post_meetup_go_to_chat_button: "Ir al chat",
  post_meetup_rematch_button: "Rehacer match",
  post_meetup_rematch_waiting_title:
    "Esperando a que {name} rehaga el match...",
  post_meetup_rematch_waiting_subtitle:
    "Tocaste Rehacer match. Si {name} también lo hace, se restablecerá vuestra conexión.",
  post_meetup_chat_expired_message: "Este match ha caducado.",
  post_meetup_chat_expired_subtitle:
    "Ambos tenéis que rehacer el match para seguir la conversación.",
  post_meetup_remaining: "{time} restante",
  post_meetup_confirm_title: "¿Te encontraste con {name} en {event}?",
  post_meetup_confirm_yes: "Sí, nos vimos",
  post_meetup_confirm_not_yet: "Todavía no",
  post_meetup_confirm_did_not_meet: "No nos vimos",
  post_meetup_pending_title: "ESPERANDO TU RESPUESTA ({count})",
  post_meetup_pending_respond: "Responder",
};
